import { IsInt, IsOptional, IsString } from 'class-validator';
import { Type } from 'class-transformer';

export class BaseSearchQueryParamsDto {
  @IsOptional()
  @IsInt()
  @Type(() => Number)
  page: number;

  @IsOptional()
  @IsInt()
  @Type(() => Number)
  limit: number

  @IsOptional()
  @IsString()
  search: string;

  @IsOptional()
  @IsString()
  sort: string;
}
